import 'lightgallery.js';
import lgVideo from 'lg-video.js';

const _playButton = document.getElementById('video-play-button');

if (_playButton) {
	lightGallery(_playButton, {
		counter: false,
		selector: 'this',
		plugins: [lgVideo],
	});
}
